import { type FC, type PropsWithChildren, useState } from 'react';

import { RestoreEnergyContext } from './context';
import { RestoreEnergy } from './RestoreEnergy';

const ResotreEnergyProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <RestoreEnergyContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
      <RestoreEnergy setIsOpen={setIsOpen} isOpen={isOpen} />
    </RestoreEnergyContext.Provider>
  );
};

export { ResotreEnergyProvider };
